import React from "react"
import { Alert } from "antd"

import { W1 } from "@components"
import { US_STATE_OPTIONS } from "@components/Address"
import { Disclaimer, Markdown } from "@components/Text"
import { TYPE_BOOLEAN, TYPE_STRING, TYPE_NONE } from "@components/Form"

import { getNoEinAlert, TITLE_WARNING } from "./getProfileEntityOtherSchema"

const TOOLTIP_NON_US_PERSON = `
For federal tax purposes, you are considered a U.S. person if you are:
An individual who is a U.S. citizen or U.S. resident alien;
A partnership, corporation, company, or association created or organized in the United States or under the laws of the United States;
An estate (other than a foreign estate); or
A domestic trust (as defined in Regulations section 301.7701-7).
`


const computeResidencyInputs = (profile, updateSchema, labels = { isUsPerson : "" }, organizationEmail = "") => {
  const noSsnAlertMessage = getNoEinAlert(organizationEmail)

  const typesMap = {
    hasOtherUsResidenceState: TYPE_NONE,
    isUsPerson: TYPE_NONE,
    residenceState: TYPE_NONE,
    hasSsn: TYPE_NONE,
    hasEinNumber:  TYPE_NONE
  }

  const { isUsPerson, hasOtherUsResidenceState, isUsCitizen, hasSsn } = profile
  const isNotUsCitizen = isUsCitizen  === false
  const showResidenceState = (isUsCitizen && hasOtherUsResidenceState) || (isNotUsCitizen && isUsPerson && hasOtherUsResidenceState)
  const showHasOtherUsResidenceState = isUsCitizen || (isNotUsCitizen && isUsPerson)

  if (isUsCitizen) {
    typesMap.hasOtherUsResidenceState = TYPE_BOOLEAN

    if (hasOtherUsResidenceState) {
      typesMap.residenceState = TYPE_STRING
    }
  }

  if (isNotUsCitizen) {
    typesMap.isUsPerson = TYPE_BOOLEAN
  } else {
    typesMap.isUsPerson = TYPE_NONE
  }

  if (showHasOtherUsResidenceState) {
    typesMap.hasOtherUsResidenceState = TYPE_BOOLEAN
  }

  if (showResidenceState) {
    typesMap.residenceState = TYPE_STRING
  } else {
    typesMap.residenceState = TYPE_NONE
  }

  const statesInputs = [
    {
      name: "hasOtherUsResidenceState",
      type: typesMap.hasOtherUsResidenceState,
      required: true,
      /* td: we can include state to make it more clear */
      label: labels.hasOtherUsResidenceState || `
        Is the state listed under your address also your state of residence
        for tax purposes?
      `,
      inputProps: {
        hasInvertedValues: true,
        onChange: () => updateSchema()
      }
    },
    {
      name: "residenceState",
      type: typesMap.residenceState,
      label: labels.residenceState || "Please list your state of residence",
      options: US_STATE_OPTIONS,
      required: true,
      placeholder: "",
      inputProps: {
        style: { width: 180 }
      }
    }
  ]

  const doYouHaveSsnExtra = hasSsn === false
    ? (
        <Alert
          showIcon
          type="warning"
          style={{ marginTop: W1 }}
          message={TITLE_WARNING}
          description={<Markdown text={noSsnAlertMessage} />}
        />
      )
    : undefined

  if (isUsCitizen) {
    return [
      ...[{
        name: "isUsPerson",
        required: true,
        type: typesMap.isUsPerson,
        label: labels.isUsPerson,
        itemProps: {
          extra: <Disclaimer text={TOOLTIP_NON_US_PERSON} />
        },
        inputProps: {
          onChange: () => updateSchema()
        }
      }],
      ...statesInputs,
      ...[
        {
          name: "hasSsn",
          type: TYPE_BOOLEAN,
          required: true,
          label: labels.hasSsn || "Do you have an SSN?",
          itemProps: {
            extra: doYouHaveSsnExtra
          },
          inputProps: {
            onChange: () => updateSchema()
          }
        }
      ]
    ]
  }

  return [
    ...[{
      name: "isUsPerson",
      required: true,
      type: typesMap.isUsPerson,
      label: labels.isUsPerson,
      itemProps: {
        extra: <Disclaimer text={TOOLTIP_NON_US_PERSON} />
      },
      inputProps: {
        onChange: () => updateSchema()
      }
    }],
    ...statesInputs,
    ...[
      {
        name: "hasSsn",
        type: TYPE_BOOLEAN,
        required: true,
        label: labels.hasSsn || "Do you have an SSN?",
        itemProps: {
          extra: doYouHaveSsnExtra
        },
        inputProps: {
          onChange: () => updateSchema()
        }
      }
    ]
  ]
}

export default computeResidencyInputs
